import { CNT_KEY, formatPhoneNumber } from "../../components/ContactForm/helpers";
import { months } from "../../components/constant";

export const buildIcxAppRequest = (projectData,sectionData,appType,programData,userData,actionType) =>{
  console.log(userData?.profile)
  const customer = sectionData.find((x) => x?.id === 1)?.data;
  const applicant = sectionData.find((x) => x?.id === 2)?.data;
  const installer = sectionData.find((x) => x?.id === 3)?.data;
    return {
        "programId": projectData?.programId ?? "",
        "projectId": projectData?.projectId ?? "",
        "status": "",
        "appType": projectData?.appType ?? appType,
        "actionType":actionType,
        "appPrjctNmCalc": customer?.[CNT_KEY.PRJ_NM],
        "enrolment": {
          "appType": projectData?.appType ?? appType,
          "appNb": projectData?.appNb ?? "",
          "applicantInformation": {
            ...applicant,
            "contactType": "Applicant",
            "contactId":'',
          },
          "applicationOwner" :{
            "firstName": userData?.profile?.firstName,
            "lastName": userData?.profile?.lastName,
            "email": userData?.profile?.email,
            "address1": userData?.profile?.streetAddress,
            "address2": userData?.profile?.streetAddress2,
            "city": userData?.profile?.city,
            "state": userData?.profile?.state,
            "zipCode":  userData?.profile?.zipCode,
            "contactNo": "",
            "mobileNo":  userData?.profile?.mobilePhone,
            "companyName": userData?.profile?.companyName,
            "contactType": "ApplicationOwner",
            "contactId": "",
            "aepUserId":(userData?.profile?.AzureAD_IDPUser && userData?.profile?.login) ? userData?.profile?.login.match(/^.+(?=@)/)[0]:null
          },
          "contractor": {
            ...installer,
            "contactType": "Installer",
            "contactId":''
          },
          "customer": {
            ...customer,
            "customerNb": "",
            "StateCode":customer?.[CNT_KEY.STATE],
            "Jurisdiction":customer?.[CNT_KEY.STATE],
            "accountNb": customer?.[CNT_KEY.CONTYPE]==="accNo"? customer?.[CNT_KEY.CONID]:"",
            "premiseNb": "",
            "ezId": customer?.[CNT_KEY.CONTYPE]!=="accNo"? customer?.[CNT_KEY.CONID]:"",
            "contactType": "Customer",
            "contactId":''
          },
          "poi": {
            "address1": customer?.[CNT_KEY.ADD1],
            "address2": customer?.[CNT_KEY.ADD2],
            "city": customer?.[CNT_KEY.CITY],
            "state": customer?.[CNT_KEY.STATE],
            "contactType": "POI",
            "zipCode": customer?.[CNT_KEY.ZIP],
            "latitude": customer?.[CNT_KEY.LAT],
            "longitude": customer?.[CNT_KEY.LONG],
          },
          "customerPrograms": programData.map(pgm=>buildProgramObject(pgm)),
          "attachments": []
        }
      }
}

const buildProgramObject = (program) => {
  return  {
    "equipmentModule": {
      "inverters":program?.data?.inverters.map(iv=>buildInverterApiObject(iv)),
      "integratedEnergySystems": program?.data?.integratedEnergySystems.map(ies=>buildIESApiObject(ies)),
      "otherGenerators": [
        {
          "assetId":'',
          "fuelType": "",
          "genType": "",
          "powerType": "",
          "setCapacityKW": 0,
          "maxCapacityKW": 0,
          "minCapacityKW": 0,
          "powerFactor": 0,
          "meter": true,
          "customerMeters": [
            {
              "meterNb": "string",
              "meterType": "string"
            }
          ],
          "mfrName": "string",
          "modelName": "string",
          "unitQy": 0
        }
      ],
      "loadMeterNb": "",
      "customerSubPrograms": [
        {
          "programSubType": "",
          "typeOfMesasure": "",
          "contractRate": 0
        }
      ]
    },
    "owner": {
      "firstName": "",
      "lastName": "",
      "email": "",
      "address1": "",
      "address2": "",
      "city": "",
      "state": "NY",
      "zipCode": "",
      "contactNo": "",
      "mobileNo": "",
      "companyName": "",
      "contactType": "Customer"
    },
    "aggregator": {
      "firstName": "",
      "lastName": "",
      "email": "",
      "address1": "",
      "address2": "",
      "city": "",
      "state": "NY",
      "zipCode": "",
      "contactNo": "",
      "mobileNo": "",
      "companyName": "",
      "contactType": "Customer"
    },
    "programType": "BTM",
    "programSubType": program?.programType,
    "programName": program?.programType,
    "programId":program?.pgmId,
    "cisProgramCode": "",
    "cisTariffCode": "",
    "cisTariffPoint": "",
    "systemSize": 0
  }
}

export const rebuildProgramState = (program) => {
  return  {
    pgmId:program?.programId,
    data:{
      inverters:program?.equipmentModule?.inverters?.map(iv=>rebuildInverterState(iv)),
      integratedEnergySystems:program?.equipmentModule?.integratedEnergySystems?.map(ies=>rebuildIESState(ies)),
    },
    programType:program?.programSubType,
}
}


const buildBatteryObject= (battery) => {
  return {
    "assetId":battery?.pId,
    "setCapacityKWH": battery?.modelData?.NMP_CAPACITY_KWH,
    "maxContDischargeRateKW": battery?.modelData?.MAX_CONT_DISC_RATE_KW,
    "mfrName": battery?.data?.mfrName,
    "modelName": battery?.data?.modelName,
    "unitQy": battery?.data?.unitQy
  }
}

const reBuildBatteryState = (battery) =>{
  return{
    pId: battery?.assetId,
    data:{
      "mfrName": battery?.mfrName,
      "modelName": battery?.modelName,
      "unitQy": battery?.unitQy
    },
    mdl:[{MFR_NM:battery?.mfrName,MDL_NM:battery?.modelName}],
    modelData:{
      NMP_CAPACITY_KWH:battery.setCapacityKWH,
      MAX_CONT_DISC_RATE_KW:battery.maxContDischargeRateKW
    }
  }
}

const buildSolarObject= (solar) => {
  return {
    "assetId":solar?.pId,
    "setCapQy": 0,
    "maxCapQy": 0,
    "tilt": solar?.data?.tilt,
    "azimuth": solar?.data?.azimuth,
    "tracking": solar?.data?.tracking,
    "shading": months.map(element => { return{
      "month": element,
      "shadeQty": solar?.data?.[element]
    }}),
    "mfrName": solar?.data?.mfrName,
    "modelName": solar?.data?.modelName,
    "unitQy": solar?.data?.unitQy
  }
}
const rebuildSolarState = (solar) =>{
  return {
    pId:solar.assetId,
    mdl:[{MFR_NM:solar?.mfrName,MDL_NM:solar?.modelName}],
    data:{
      mfrName: solar.mfrName,
      modelName:solar.modelName,
      unitQy:solar.unitQy,
      tilt:solar.tilt||0,
      azimuth:solar.azimuth||0,
      tracking:solar.tracking||'single',
      ...(months?.reduce((a, v) => ({ ...a, [v]:0}), {}))
     // ...(solar?.shading?.reduce((a, v) => ({ ...a, [v?.month]: v?.shadeQty||11}), {}))
  }
  }
}

const buildInverterApiObject = (inverter) => {
return {
  "assetId":inverter?.eqId,
  "hybridPVBattery": inverter?.modelData?.HYBRID_PV_BTRY ==="Y",
  "inverterType":  inverter?.modelData?.INVERTERTYPE,
  "maxContPowerKW": inverter?.modelData?.MAX_CONT_PWR_UPF_KW,
  "microInverter": inverter?.modelData?.MICRO_INVERTER ==="Y",
  "solarArrays": inverter?.solar?.map(solar => buildSolarObject(solar)),
  "batteries": inverter?.battery?.map(bt =>buildBatteryObject(bt)),
  "meter": true,
  "customerMeters": [
    {
      "meterNb": "string",
      "meterType": "string"
    }
  ],
  "mfrName": inverter?.data?.mfrName,
  "modelName": inverter?.data?.modelName,
  "unitQy": inverter?.data?.unitQy
}
}

const rebuildInverterState = (inverter) => {
  return {
    "eqId":inverter?.assetId,
    modelData:{
      HYBRID_PV_BTRY: inverter?.hybridPVBattery?"Y":"N",
      INVERTERTYPE:inverter?.inverterType,
      MAX_CONT_PWR_UPF_KW:inverter?.maxContPowerKW,
      MICRO_INVERTER:inverter?.microInverter?"Y":"N"
    },
    solar:inverter?.solarArrays?.map(solar=>rebuildSolarState(solar)),
    battery: inverter?.batteries?.map(bt =>reBuildBatteryState(bt)),
    mdl:[{
      MFR_NM:inverter?.mfrName,
      MDL_NM:inverter?.modelName,
      HYBRID_PV_BTRY: inverter?.hybridPVBattery?"Y":"N",
      INVERTERTYPE:inverter?.inverterType,
      MAX_CONT_PWR_UPF_KW:inverter?.maxContPowerKW,
      MICRO_INVERTER:inverter?.microInverter?"Y":"N"
    }],
    data:{
      "mfrName": inverter?.mfrName,
      "modelName": inverter?.modelName,
      "unitQy": inverter?.unitQy
    }
  }
  }

const buildIESApiObject = (ies)=>{
  return {
    "assetId":ies?.eqId,
    "pvdcInputCapability": ies?.modelData?.PV_DC_INP_CAPABILITY==='Y',
    "setCapacityKWH": ies?.modelData?.NMP_CAPACITY_KWH,
    "maxContDischargeRateKW": ies?.modelData?.MAX_CONT_DISC_RATE_KW,
    "setPowerKw": ies?.modelData?.NMP_POWER_KW,
      "solarArrays": ies?.solar.map(sl =>buildSolarObject(sl)),
    "meter": true,
    "customerMeters": [
      {
        "meterNb": "string",
        "meterType": "string"
      }
    ],
    "mfrName": ies?.data?.mfrName,
    "modelName": ies?.data?.modelName,
    "unitQy": ies?.data?.unitQy
  }
}

const rebuildIESState = (ies)=>{
  return {
     eqId:ies?.assetId,
     modelData:{
      PV_DC_INP_CAPABILITY:ies?.pvdcInputCapability?"Y":"N",
      NMP_CAPACITY_KWH:ies?.setCapacityKWH,
      MAX_CONT_DISC_RATE_KW:ies?.maxContDischargeRateKW,
      NMP_POWER_KW:ies?.setPowerKw
     },
     solar:ies?.solarArrays.map(sl =>rebuildSolarState(sl)),
     data:{
      "mfrName": ies?.mfrName,
      "modelName": ies?.modelName,
      "unitQy": ies?.unitQy
     },
     mdl:[{MFR_NM:ies?.mfrName,
      MDL_NM:ies?.modelName,
      PV_DC_INP_CAPABILITY:ies?.pvdcInputCapability?"Y":"N",
      NMP_CAPACITY_KWH:ies?.setCapacityKWH,
      MAX_CONT_DISC_RATE_KW:ies?.maxContDischargeRateKW,
      NMP_POWER_KW:ies?.setPowerKw}],

  }
}

export const reBuildCntGenData = (apiData) => {
  if(apiData){
    return {
      ...apiData,
      [CNT_KEY.VALIDZIP]: apiData?.zipCode ? true :false,
      [CNT_KEY.MOBILE]: formatPhoneNumber(apiData?.mobileNo || apiData?.contactNo), 
    }
  }
}

export const reBuildCustomerData = (apiData) => {
  const customerData  = apiData?.customer
  if(customerData){
    return {
      ...customerData,
      [CNT_KEY.PRJ_NM]: apiData?.projectName ?? '',
      [CNT_KEY.VALIDCON]:  true,
      [CNT_KEY.HVCONN]:(customerData?.accountNb || customerData?.ezId) ? 'yes' :'no',
      [CNT_KEY.VALIDZIP]: customerData?.zipCode ? true :false,
      [CNT_KEY.MOBILE]: formatPhoneNumber(customerData?.mobileNo || customerData?.contactNo),
      [CNT_KEY.CONID]: customerData?.accountNb  ||  customerData?.ezId,
      [CNT_KEY.CONTYPE]: customerData?.accountNb ? 'accNo' : customerData?.ezID ? 'ezId':''
    }
  }
}